import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { PaymentModel } from 'src/app/admin-panel/models/business/payment.model';
import { SearchPaymentModel } from 'src/app/admin-panel/models/business/search-payment.model';
import { DropdownHelperModel } from 'src/app/admin-panel/models/helpers/dropdown-helper.model';
import { PaymentService } from 'src/app/admin-panel/services/business/payment.service';
import { ArchivePaymentComponent } from './archive-payment/archive-payment.component';
import { DetailsPaymentComponent } from './details-payment/details-payment.component';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent implements OnInit {

  //#region Fields
  public imagePath: string = './assets/images/icons/venue-logo-placeholder.png'
  public src_drop_opt: Array<DropdownHelperModel>;
  public src_drop_opt_1: DropdownHelperModel;
  public src_drop_opt_2: DropdownHelperModel;
  public selected_drop_opt: DropdownHelperModel;
  public searchPaymentModel: SearchPaymentModel = new SearchPaymentModel();
  public spinner: boolean = false;
  public unsubscribe: Subject<void> = new Subject<void>();
  public totalPages: number;
  public totalRecords: number;
  public paymentList: Array<PaymentModel>;

  //#endregion
  //#region Constructor
  constructor(
    public dialogService: DialogService,
    public paymentService: PaymentService,
    private messageService: MessageService) {
    this.src_drop_opt = new Array<DropdownHelperModel>();
    this.src_drop_opt_1 = new DropdownHelperModel()
    this.src_drop_opt_1.id = '1';
    this.src_drop_opt_1.name = 'A_Z';
    this.src_drop_opt_2 = new DropdownHelperModel()
    this.src_drop_opt_2.id = '2';
    this.src_drop_opt_2.name = 'Z_A';
    this.src_drop_opt.push(this.src_drop_opt_1);
    this.src_drop_opt.push(this.src_drop_opt_2);

    this.paymentList = new Array<PaymentModel>();

  }

  ngOnInit(): void {
    this.getpayments(this.searchPaymentModel)
  }
  //#endregion
  //#region Public Methods

  getpayments(searchModel: SearchPaymentModel) {
    this.spinner = true;
    this.paymentService.getpayments(searchModel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.totalPages = response.totalPages;
          this.totalRecords = response.totalRecords;
          if (this.searchPaymentModel.pageNumber > 1) {
            this.paymentList = this.paymentList.concat(response.data)
          }
          else {
            this.paymentList = response.data;
          }
          this.spinner = false;
        },
        error: errorResponse => {
          this.spinner = false;
          if (errorResponse.error) {
            this.messageService.add({ severity: 'error', summary: "Server Error", life: 2000 });
          }
        }
      });

  };

  loadMorePayments() {
    this.searchPaymentModel.pageNumber = this.searchPaymentModel.pageNumber + 1;
    this.getpayments(this.searchPaymentModel);
  }
  detailsPayment(id: string) {
    const ref = this.dialogService.open(DetailsPaymentComponent, {
      data: {
        id: id
      },
      header: 'Details Payment',
      width: '760px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  archivePayment(id: string) {
    const ref = this.dialogService.open(ArchivePaymentComponent, {
      data: {
        id: id
      },
      header: 'Archive Payment',
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  searchPayment(searchModel: SearchPaymentModel) {
    this.paymentList = new Array<PaymentModel>();
    if (this.selected_drop_opt.id == '1') {
      searchModel.isAsc = true;
    } else if (this.selected_drop_opt.id == '2') {
      searchModel.isAsc = false;
    }
    searchModel.pageNumber = 1;
    this.getpayments(this.searchPaymentModel)
  }
  clearSearch() {
    this.searchPaymentModel.name = "";
    this.searchPaymentModel.city = "";
    this.paymentList = new Array<PaymentModel>();
    this.getpayments(this.searchPaymentModel)
  }
  changeSortBy() {
    this.searchPayment(this.searchPaymentModel);
  }
  //#endregion
  //#Private Methods
  //#endregion
}
